<template lang="pug">
  vm-prompt(vm-size="medium" @vm-cancel="close" @vm-accept="save" @vm-close="close" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="false" :vm-active="isModalContactVisible" :vm-title='getTitle')
    .group
      vm-row.separador(vm-type="flex" vm-w="12" v-for="(column, index) in employees")
        vm-col(vm-justify="left", vm-align="left", vm-w=3)
          h3 {{ employees[index]['contact'] }}:
        vm-col(vm-justify="center", vm-align="center", vm-w=3)
          h3 {{ employees[index]['email'] }}
        vm-col(vm-justify="center", vm-align="center", vm-w=3)
          h3 {{ employees[index]['phone'] }}:
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=3)
          toogle(:flag="contacts_flag[index]" @selected="selectContact(employees[index]['id'])" @unselected="unSelectContact(employees[index]['id'])")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('ProjectContacts')

export default {
  name: 'ModalSelectContact',
  components: {
    toogle: () => import('@/components/aditionals/ToogleSelect.vue')
  },
  props: {
    project_id: {
      type: Number
    },
    contacts_flag: {
      type: Array
    },
    selected_contacts: {
      type: Array
    }
  },
  computed: {
    ...mapGetters([
      'isModalContactVisible',
      'employees'
    ]),
    getTitle () {
      return this.$t('projects.contact')
    }
  },
  methods: {
    ...mapActions([
      'selectContacts',
      'setModalContactVisible',
      'saveContacts',
      'loadToQuotes',
      'loadQuotes',
      'loadQuoting',
      'loadInOrders',
      'loadFinisheds'
    ]),
    close () {
      this.setModalContactVisible(false)
    },
    selectContact (index) {
      this.selected_contacts.push(index)
    },
    unSelectContact (index) {
      const i = this.selected_contacts.indexOf(index)
      this.selected_contacts.splice(i, 1)
    },
    async save () {
      await this.saveContacts({ id: this.project_id, contacts: this.selected_contacts }).then(() => {
        this.loadToQuotes({ page: 1, customer: this.employees[0].employer_id })
        this.loadQuotes({ page: 1, customer: this.employees[0].employer_id })
        this.loadQuoting({ page: 1, customer: this.employees[0].employer_id })
        this.loadInOrders({ page: 1 })
        this.loadFinisheds({ page: 1 })
        this.selected_contacts = []
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.separador {
  padding-bottom: 10px;
}
.group {
  padding: 15px;
}
</style>
